export const CustodyLock = {
  LockInBank: 'Lock in Bank',
  LockSelf: 'Lock Self',
  Release: 'Release'
}

export const CustodyExtStatus = {
  PrintPending: 'Print Pending',
  Printed : 'Printed',
  Released: 'Released',
  Recovered: 'Recovered',
  Cancelled: 'Cancelled'
}

export const CustodyIntStatus = {
  ClientRequest: 'Client Request',
  CustodianRequest : 'Custodian Request',
  Executed: 'Executed',
  ClientReturned: 'Client Returned',
  Returned: 'Returned',
  Lost: 'Lost',
  ReturnRequested: 'Return Requested',
  CancelRequest: 'Cancel Request',
  Delivered: 'Delivered'
}

export function getIntStatusName(status) {
  switch (status) {
    case CustodyIntStatus.ClientRequest:
      return 'Client req.';
    case CustodyIntStatus.CustodianRequest:
      return 'Custodian req.'; 
    case CustodyIntStatus.Executed:
      return 'Executed';
    case CustodyIntStatus.ClientReturned:
      return 'Client ret.';
    case CustodyIntStatus.Returned:
      return 'Returned';
    case CustodyIntStatus.Lost:
      return 'Lost'; 
    case CustodyIntStatus.ReturnRequested:
      return 'Return req.';
    case CustodyIntStatus.CancelRequest:
      return 'Cancel req.';
    case CustodyIntStatus.Delivered:
      return 'Delivered';
  }
}
